import { useSuspenseQueries } from '@tanstack/react-query';
import { featureFlagQueryOptions } from '#api/org.queries.ts';
import { tagsCountQueryOptions } from '#api/tags.queries.ts';

export function useSuspenseIsTagsLimitReached() {
  const [
    { data: tagsCount },
    {
      data: { CONFIG_TAGS_LIMIT },
    },
  ] = useSuspenseQueries({
    queries: [tagsCountQueryOptions, featureFlagQueryOptions],
  });

  // This should be defined, but the types are a bit weak
  if (CONFIG_TAGS_LIMIT === undefined) {
    throw new Error('Could not get tag count and/or tag limit');
  }

  return {
    /** Have we reached or surpassed the {@link CONFIG_TAGS_LIMIT}? */
    isTagsLimitReached: tagsCount >= CONFIG_TAGS_LIMIT,
    tagsLimit: CONFIG_TAGS_LIMIT,
  };
}
